import { render, staticRenderFns } from "./PopTerm.vue?vue&type=template&id=53974d6a&scoped=true&"
import script from "./PopTerm.vue?vue&type=script&lang=js&"
export * from "./PopTerm.vue?vue&type=script&lang=js&"
import style0 from "./PopTerm.vue?vue&type=style&index=0&id=53974d6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53974d6a",
  null
  
)

export default component.exports